import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  CardMedia,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { UseAddOrder } from "./UseAddOrder";
import { UseOrders } from "../OrdersPage/UseOrders";
import { useSnackbar } from "notistack";
import "leaflet/dist/leaflet.css";
import { MapContainer } from "react-leaflet";
import MapOrder from "./MapOrder";
import useBreakpoints from "../../hooks/useBreakpoints";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import SendDetail from "./SendDetail";
import LocDetail from "./LocDetail";
import PaymentDetail from "./PaymentDetail";
import UserDetail from "./UserDetail";

export default function AddOrderDetail(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { getOrdersLoc, setLocationData, locations } = UseOrders();
  // const [openAddress, setOpenAddress] = useState(false);
  const [openAddress, setOpenAddress] = useState({
    show: false,
    addresses: [],
  });

  const { GetUserInfo, GetExpressDeliveryCost } = UseAddOrder();
  const [delivery, setDelivery] = useState();
  const [deliveryTimes, setDeliveryTimes] = useState([]);
  const [valueAuto, setValueAuto] = useState("");
  const [sendType, setSendType] = useState("");
  const [valuePaymentType, setValuePaymentType] = useState("");
  const [postTimes, setPostTimes] = useState([]);
  const [deliveryType, setDeliveryType] = useState([]);
  const [paymentType, setPaymentType] = useState();
  const [allDeliveryDay, setAllDeliveryDay] = useState();
  const [allDelivery, setAllDelivery] = useState(true);
  const [getPayment, setGetPayment] = useState();
  const [lastDelivery, setLastDelivery] = useState();
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);

  const [myLocations, setMyLocations] = useState({
    provinceID: props.state ? props.state.provinceID : 0,
    province: props.state ? props.state.province : 0,
    cityID: props.state ? props.state.cityID : 0,
    city: props.state ? props.state.city : 0,
    neighbourhoodID: props.state ? props.state.neighbourhoodID : 0,
    neighbourhood: props.state ? props.state.neighbourhood : 0,
    postCode: props.state ? props.state.postCode : 0,
    address: props.state ? props.state.address : 0,
    longitude: "",
    latitude: "",
    neighbourhoodMotor: false,
    neighbourhoodExpress: false,
  });

  // useEffect(() => {
  //   if (props.state) {
  //     setMyLocations({ ...myLocations, address: props.state.address });
  //   }
  // }, [props.state]);

  useEffect(() => {
    if (!props.state.orderID) {
      setOpenAddress({
        show: false,
        addresses: [],
      });
    }
  }, [props.state]);

  useEffect(() => {
    if (delivery && delivery.deliveryDays !== null) {
      setValueAuto({ name: "" });
      var tempArr = [];
      delivery.deliveryDays &&
        delivery.deliveryDays.map((m) => {
          m.deliveryTimes?.map((model) => {
            model.name = m.day + " " + m.date + " " + model.title;
            model.deliveryID = model.deliveryID;
            model.isFull = model.isFull;
            model.disable = model.disable;
            tempArr.push(model);
            setDeliveryTimes(tempArr);
          });
        });
    }
    if (delivery && !delivery.deliveryDays) {
      if (delivery.title == "ارسال سریع با پیک موتوری") {
        setValueAuto({ name: delivery.description });
        return;
      }
      setValueAuto({ name: delivery.deliveryTitle });
      props.setState({
        ...props.state,
        deliveryID: delivery.deliveryID,
      });
      setPostTimes(delivery);
    }
  }, [delivery]);

  useEffect(() => {
    if (props.expanded == "panel2") {
      getOrdersLoc(props.orderID, (provinces) => {
        provinces.motorcycleDelivery?.map((m) => {
          m.disable = !myLocations.neighbourhoodMotor;
          return m;
        });

        let temp = provinces.motorcycleDelivery ?? [];
        let tempLength = provinces.motorcycleDelivery?.length;
        let inpersonDeliveryLength =
          provinces.motorcycleDelivery?.length +
            provinces.postDelivery?.length ?? 0;

        let expressDeliveryLength =
          provinces.motorcycleDelivery?.length +
          provinces.postDelivery?.length +
          provinces.inpersonDelivery?.length;

        provinces.postDelivery?.map((m) => {
          m.id = m.id + tempLength;
          temp.push(m);
        });

        provinces.inpersonDelivery?.map((m) => {
          m.id = m.id + inpersonDeliveryLength + 1;
          temp.push(m);
        });

        provinces.expressDelivery?.map((m) => {
          m.disable = !myLocations.neighbourhoodExpress;
          m.id = m.id + expressDeliveryLength + 1;
          temp.push(m);
        });

        setDeliveryType(temp);
        setAllDeliveryDay(provinces.allMotorcycleDelivery);
        setPaymentType(provinces.payments);
        setLocationData(provinces.provinces);
      });
    } else if (props.expanded == "panel1") {
      setDeliveryTimes([]);
      setValueAuto({ name: "" });
      setSendType({ title: "" });
      setValuePaymentType({
        title: "",
      });
      setPostTimes([]);
      setDelivery();
      props.setState({
        ...props.state,
        deliveryType: "",
      });
    }
  }, [myLocations, props.expanded, getPayment]);

  useEffect(() => {
    if (openAddress.show) {
      setMyLocations({
        ...myLocations,
        provinceID: props.state ? props.state.provinceID : 0,
        cityID: props.state ? props.state.cityID : 0,
        neighbourhoodID: props.state ? props.state.neighbourhoodID : 0,
        // longitude: props.state ? props.state.longitude : 35.7009,
        // latitude: props.state ? props.state.latitude : 51.391241,
      });
    }
  }, [openAddress]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <LocDetail
        setOpenAddress={setOpenAddress}
        openAddress={openAddress}
        setMyLocations={setMyLocations}
        myLocations={myLocations}
        state={props.state}
        setState={props.setState}
        setDeliveryType={setDeliveryType}
        setSendType={setSendType}
        setValueAuto={setValueAuto}
        setDelivery={setDelivery}
        errorState={props.errorState}
        allDeliveryDay={allDeliveryDay}
        allDelivery={allDelivery}
        sendType={sendType}
        delivery={delivery}
        deliveryTimes={deliveryTimes}
        locations={locations}
        setGetPayment={setGetPayment}
        getPayment={getPayment}
        paymentType={paymentType}
        deliveryType={deliveryType}
        setLastDelivery={setLastDelivery}
        setDeliveryTimes={setDeliveryTimes}
        setAllDelivery={setAllDelivery}
        setRow={props.setRow}
        row={props.row}
        valueAuto={valueAuto}
      />
      <UserDetail
        setOpenAddress={setOpenAddress}
        openAddress={openAddress}
        setMyLocations={setMyLocations}
        myLocations={myLocations}
        state={props.state}
        setState={props.setState}
        getPayment={getPayment}
        setDeliveryType={setDeliveryType}
        setSendType={setSendType}
        setValueAuto={setValueAuto}
        setDelivery={setDelivery}
        errorState={props.errorState}
        allDeliveryDay={allDeliveryDay}
        allDelivery={allDelivery}
        sendType={sendType}
        delivery={delivery}
        deliveryTimes={deliveryTimes}
        setGetPayment={setGetPayment}
        paymentType={paymentType}
        deliveryType={deliveryType}
        setLastDelivery={setLastDelivery}
        setDeliveryTimes={setDeliveryTimes}
        setAllDelivery={setAllDelivery}
        setRow={props.setRow}
        row={props.row}
        valueAuto={valueAuto}
      />
      <SendDetail
        setOpenAddress={setOpenAddress}
        openAddress={openAddress}
        setMyLocations={setMyLocations}
        myLocations={myLocations}
        state={props.state}
        setState={props.setState}
        getPayment={getPayment}
        setDeliveryType={setDeliveryType}
        setSendType={setSendType}
        setValueAuto={setValueAuto}
        setDelivery={setDelivery}
        errorState={props.errorState}
        allDeliveryDay={allDeliveryDay}
        allDelivery={allDelivery}
        sendType={sendType}
        delivery={delivery}
        deliveryTimes={deliveryTimes}
        paymentType={paymentType}
        setGetPayment={setGetPayment}
        deliveryType={deliveryType}
        setLastDelivery={setLastDelivery}
        setDeliveryTimes={setDeliveryTimes}
        setAllDelivery={setAllDelivery}
        setRow={props.setRow}
        row={props.row}
        valueAuto={valueAuto}
      />
      <PaymentDetail
        setOpenAddress={setOpenAddress}
        openAddress={openAddress}
        row={props.row}
        setRow={props.setRow}
        setMyLocations={setMyLocations}
        myLocations={myLocations}
        state={props.state}
        setState={props.setState}
        getPayment={getPayment}
        setDeliveryType={setDeliveryType}
        setSendType={setSendType}
        setValueAuto={setValueAuto}
        setDelivery={setDelivery}
        errorState={props.errorState}
        allDeliveryDay={allDeliveryDay}
        allDelivery={allDelivery}
        sendType={sendType}
        delivery={delivery}
        deliveryTimes={deliveryTimes}
        paymentType={paymentType}
        setGetPayment={setGetPayment}
      />
    </Box>
  );
}
